const cookieBannerTrackingEvent = action => [{
  topic: 'tracking-event',
  data: {
    ga: [{
      category: 'cookie-banner',
      action: `Cookie Policy ${action}`
    }]
  }
}];
export { cookieBannerTrackingEvent };